export default __webpack_public_path__ + "22faae3ae9cce329218e35d653e04aba.svg";